import React from 'react';
import { Col } from '@amzn/atoz-web/Col';
import { Row } from '@amzn/atoz-web/Row';
import { Text } from '@amzn/atoz-web/Text';
import { WEEKLY_SCHEDULE_EVENT_LEGEND } from '../../testids.consts';
export var EventLegend = function (_a) {
    var icon = _a.icon, label = _a.label;
    return (React.createElement(Col, { dataTestId: WEEKLY_SCHEDULE_EVENT_LEGEND },
        React.createElement(Row, { alignItems: "center", justifyContent: "center" },
            React.createElement(Col, null, icon),
            React.createElement(Col, null,
                React.createElement(Text, { fontSize: 'T200' }, label)))));
};
